import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

function FormEmails__Details(props) {
    const { formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                inputType={"text"} // type of the input number,text etc
                stFormClass={"st-form-with-label-left no-arrows d-flex flex-wrap align-items-center"} // class name for main wrapper
                isRequired={true} // is this field is required or not to show the red star sign
                labelName={"Template Name"} // label name
                placeholder={"Template Name"} // placeholder for the input
                formikFieldName={"emailTemplateName"} // important: formik value name for the input
            />


            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Event Name"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"emailEventName"} // important: formik value name for the input
            >
                <option disabled value="">Select Event Name</option>
                {
                    (props.emailEvents && props.emailEvents.length) && props.emailEvents.map(item => (
                        <option
                            key={item.event_id.toString()}
                            value={item.event_id.toString()}>{item.event_title}</option>
                    ))
                }
            </AppFormikSelectInline>

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"To"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"emailTo"} // important: formik value name for the input
            >
                <option disabled value="">Select To</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
            </AppFormikSelectInline>

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                inputType={"text"} // type of the input number,text etc
                stFormClass={"st-form-with-label-left no-arrows d-flex flex-wrap align-items-center"} // class name for main wrapper
                // isRequired={true} // is this field is required or not to show the red star sign
                labelName={"From"} // label name
                placeholder={"From"} // placeholder for the input
                formikFieldName={"emailFrom"} // important: formik value name for the input
            />


            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Subject"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Subject"} // placeholder for the input
                formikFieldName={"emailSubject"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"CC"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"CC"} // placeholder for the input
                formikFieldName={"emailCC"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                inputType={"text"} // type of the input number,text etc
                stFormClass={"st-form-with-label-left no-arrows d-flex flex-wrap align-items-center"} // class name for main wrapper
                isRequired={false} // is this field is required or not to show the red star sign
                labelName={"BCC"} // label name
                placeholder={"BCC"} // placeholder for the input
                formikFieldName={"emailBCC"} // important: formik value name for the input
            />

        </React.Fragment>
    )
}


export default memo(FormEmails__Details)